/* eslint-disable import/no-anonymous-default-export */
import axios, { CancelToken } from "axios";
import { ToastMessageType } from "primereact/toast";
import { toastRef } from "../components/Layout/Layout";
import { IPartialSignatureAX, IScanner } from "../shared/interfaces";
import ErrorUtilities from "../shared/Utilities/errorUtilities";





const axiosInstance = axios.create({});


axiosInstance.interceptors.response.use(response => {
    return response
},
    error => {
        const encodedCurrentUrl = encodeURIComponent(window.location.href);
        error = extractError(error, encodedCurrentUrl);

        return Promise.reject(error);
    }
);



const extractError = (error: any, encodedCurrentUrl: string) => {
    if (axios.isCancel(error)) {
        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
        console.log(error.message);
    }
    else if (error.response && error.response.status === 403 && !ErrorUtilities.InstanceOfMyArgumentException(error.response.data)) {
        var loginPageUrl = `${window.location.origin}/api/Users/login?redirectUrl=${encodedCurrentUrl}`;
        window.location.href = loginPageUrl;
    }
    else {

        ///Restituisce Null se l'errore non è di tipo MyArgumentException
        let toastMessage: ToastMessageType | null = ErrorUtilities.GetToastPropFromMyArgumentException(error);
        if (toastMessage) {
            toastRef.current?.show(toastMessage);
            /// setto isErrorShown per impedire che venga mostrato un secondo alert 
            error = { ...error, isErrorShown: true };
        }
    }
    return error;
}

const setPeripheralServiceBaseUrl = (baseUrl: string) => {
    axiosInstance.defaults.baseURL = baseUrl;

}


const serviceIsAlive = (cancelToken?: CancelToken): Promise<string[]> => {
    return axiosInstance.get(`/api/Printer/IsAlive`, { cancelToken: cancelToken })
        .then(result => {
            return result.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

const getScanners = (cancelToken?: CancelToken): Promise<IScanner[]> => {
    return axiosInstance.get(`/api/Scanner/GetScanners`, { cancelToken: cancelToken })
        .then(result => {
            return result.data
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

const loadScannerCapabilities = (scannerName: string, cancelToken?: CancelToken): Promise<IScanner> => {
    return axiosInstance.get(`/api/Scanner/LoadScannerCapabilities`, { cancelToken: cancelToken, params: { scannerName } })
        .then(result => {
            return result.data
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

const scan = (scanRequestModel: any, cancelToken?: CancelToken): Promise<string> => {
    return axiosInstance.post(`/api/Scanner/Scan`, scanRequestModel, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const getPrinters = (cancelToken?: CancelToken): Promise<string[]> => {
    return axiosInstance.get(`/api/Printer/GetPrinters`, { cancelToken: cancelToken })
        .then(result => {
            return result.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

const print = (printerName: string, signature: IPartialSignatureAX, cancelToken?: CancelToken): Promise<string[]> => {
    return axiosInstance.post(`/api/Printer/Print`, signature, { cancelToken: cancelToken, params: { printerName } })
        .then(result => {
            return result.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}




export default {
    serviceIsAlive,
    setPeripheralServiceBaseUrl,
    loadScannerCapabilities,
    getScanners,
    scan,
    getPrinters,
    print
}


